import { useMemoizedDeepmerge } from '@ds/react-utils'
import { OliveDocuSignTheme } from '../docusign-themes/olive'
import { useTheme } from './useTheme'

export const useThemeTokens = () => {
  const { tokens } = useTheme()
  const themeTokens = useMemoizedDeepmerge(OliveDocuSignTheme.tokens, tokens)
  return themeTokens
}
